import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';
import { Input } from '../input/Input.js';
import { MaskInput } from '../maskInput/MaskInput.js';
import styles from './PriceInput.module.scss.js';

var maskOptions = { mask: Number, scale: 0, thousandsSeparator: ',' };
var PriceInput = function (props) { return (jsx(MaskInput, __assign({}, props, { maskOptions: maskOptions, leftElement: jsx(Input.Icon, __assign({ position: "left", className: styles.leftElement }, { children: "$" })), wrapperClassName: styles.leftElementWrapper }))); };

export { PriceInput };
